import Toast from "shared/toast";
import Flash from "shared/flash";
import { defaultAjaxParse, defaultErrorParse, defaultFriendlyParse } from "./parsers";

export function flashResponseError(response) {
  Flash.showError(defaultAjaxParse(response), true);
}

export function toastResponseError(response) {
  Toast.showError(defaultAjaxParse(response));
}

export function showFriendlyError(model, response, options) {
  Toast.showError(defaultFriendlyParse(response, model, options));
}

export function defaultErrorFn(model, response, options) {
  Toast.showError(defaultErrorParse(response, model, options));
}

export function bindErrorsToFormField(name, attr) {
  return {
    observe: "errors",
    update: function($el, val, model, options) {
      val[attr] ? $el.text(name + " " + val[attr]) : $el.text("");
      $el.closest(".form-group").toggleClass("has-error", !!val[attr]);
      $el.closest(".color-error").toggleClass("hidden", !val[attr]);
    }
  };
}
